import SiafLiteApiRepository from "../../external/siafLiteApi";

class OrcamentoServicoService {
  constructor() {
    this.urlBase = "/faturamento/orcamento-servicos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getOS(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/orcamento-servico`,
    ).patch(body);
  }
  
  cancelar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase(
      `/cancelar/${id}`,
    );
  }
}

export default OrcamentoServicoService;
